module.exports = __webpack_public_path__ + "media/images/users/purchases/purchase_benefit_1-3be520a3349e9957a6e18e9db9f14247.png";